export const isResponsavelAtendimentoProfissional = (
  acesso: { id: ID },
  atendimentoProfissional: { estagio?: { id: ID }; lotacao: { id: ID } }
) => atendimentoProfissional?.lotacao.id === acesso.id || atendimentoProfissional?.estagio?.id === acesso.id
